var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6568 5.65682L10.8487 4.84869L10.0406 5.65682L10.8487 6.46494L11.6568 5.65682ZM9.23245 4.84869L10.0406 5.65682L9.23245 6.46494L8.42433 5.65682L9.23245 4.84869ZM5.99996 4.84878L6.80808 5.6569L5.99996 6.46503L5.19183 5.6569L5.99996 4.84878ZM1.15122 4.84878L1.95934 5.6569L1.15122 6.46503L0.343097 5.6569L1.15122 4.84878ZM7.6162 4.84869L8.42432 5.65682L7.6162 6.46494L6.80808 5.65682L7.6162 4.84869ZM5.19183 5.65682L4.38371 4.8487L3.57559 5.65682L4.38371 6.46494L5.19183 5.65682ZM2.76747 4.84869L3.57559 5.65682L2.76747 6.46494L1.95934 5.65682L2.76747 4.84869Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusS);
export default __webpack_public_path__ + "static/media/minus-s.19405543e406b4351c668f400786b539.svg";
export { ForwardRef as ReactComponent };